var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-center text-[12px] font-medium rounded-full px-[10px] py-[2px] inline-block",style:({ backgroundColor: _vm.statusText.color.sub, color: _vm.statusText.color.main })},[_vm._v(" "+_vm._s(_vm.statusText.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }